export default "__VITE_ASSET__vdbSHjiU__"